export default __webpack_public_path__ + "static/media/logo-thecamp-cip.bab97ccd.png";